import { useState, useEffect } from "react";

export default function Typewriter({ texts }: { texts: string[] }) {
  const [index, setIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  const current = texts[index];

  useEffect(() => {
    const typeSpeed = deleting ? 60 : 120;
    const stay = 2500;

    if (!deleting && subIndex === current.length) {
      const timeout = setTimeout(() => setDeleting(true), stay);
      return () => clearTimeout(timeout);
    }

    // 刪到 0 去下一句
    if (deleting && subIndex === 0) {
      setDeleting(false);
      setIndex((index + 1) % texts.length);
      return;
    }

    const timeout = setTimeout(
      () => setSubIndex(subIndex + (deleting ? -1 : 1)),
      typeSpeed
    );
    return () => clearTimeout(timeout);
    
  }, [subIndex, deleting, index, texts, current]);

  return (
    <div className="typewriter-line">
      <span>{current.substring(0, subIndex)}</span>
      <span className="cursor">|</span>
    </div>
  );
}
const style = document.createElement('style');
style.textContent = `
    .typewriter-line {
        font-size: 18px;
        font-weight: 600;

        display: inline-flex;
        align-items: center; 
    }

    .cursor {
        margin-left: 2px;
        animation: blink 0.8s infinite;
    }

    @keyframes blink {
        0%, 50% { opacity: 0; }
        51%, 100% { opacity: 1; }
    }
    
`;
document.head.appendChild(style);